customElements.get("video-player") || customElements.define("video-player", class extends HTMLElement {
  constructor() {
    super(), this.observer = null, this.video = this.querySelector("video"), this.button = this.querySelector("button"), 
    this.hideOnPlay = this.querySelectorAll("[data-hide]"), this.video && this.hasAttribute("data-disable-controls") && (this.video.controls = !1);
  }
  disableControls=() => {
    this.video && (this.video.controls = !1);
  };
  connectedCallback() {
    if (!this.video) return !1;
    this.setupIntersectionObserver(), this.addEventListeners();
  }
  disconnectedCallback() {
    this.observer?.disconnect(), this.button?.removeEventListener("click", (() => this.play())), 
    [ "play", "playing" ].forEach((e => this.video.removeEventListener(e, this.onPlay.bind(this)))), 
    [ "pause", "ended" ].forEach((e => this.video.removeEventListener(e, this.onPause.bind(this)))), 
    this.video?.removeEventListener("mouseenter", this.onMouseEnter.bind(this)), this.video?.removeEventListener("mouseleave", this.onMouseLeave.bind(this)), 
    this.video && this.hasAttribute("data-disable-controls") && (this.video.removeEventListener("play", this.disableControls), 
    this.video.removeEventListener("pause", this.disableControls));
  }
  setupIntersectionObserver() {
    this.observer = new IntersectionObserver((e => {
      e.forEach((e => {
        e.isIntersecting || this.video.paused ? this.video.hasAttribute("autoplay") && e.isIntersecting && this.play() : this.pause();
      }));
    }), {
      root: null,
      rootMargin: "0px",
      threshold: .1
    }), this.observer.observe(this.video);
  }
  play() {
    if (this.video.readyState) return this.pauseAll(), void this.video.play();
    const e = () => {
      this.video.removeEventListener("loadeddata", e), this.play();
    };
    this.video.addEventListener("loadeddata", e), "function" == typeof this.video.load && this.video.load();
  }
  pause() {
    this.video.readyState && this.video.pause();
  }
  pauseAll() {
    document.querySelectorAll("video").forEach((e => e.readyState && e.pause()));
  }
  onPlay() {
    this.video?.classList.add("is-playing"), this.video.controls = !0, this.hideOnPlay.forEach((e => e.classList.add("hidden"))), 
    this.button.classList.add("hidden");
  }
  onPause() {
    this.video?.classList.remove("is-playing"), this.video.controls = !1, this.hideOnPlay.forEach((e => e.classList.remove("hidden"))), 
    this.button.classList.remove("hidden");
  }
  onMouseEnter() {
    this.video && this.video.paused && !this.hasAttribute("data-disable-controls") && (this.video.controls = !0);
  }
  onMouseLeave() {
    this.video && this.video.paused && !this.hasAttribute("data-disable-controls") && (this.video.controls = !1);
  }
  addEventListeners() {
    this.button?.addEventListener("click", (() => this.play())), [ "play", "playing" ].forEach((e => this.video.addEventListener(e, this.onPlay.bind(this)))), 
    [ "pause", "ended" ].forEach((e => this.video.addEventListener(e, this.onPause.bind(this)))), 
    this.video?.addEventListener("mouseenter", this.onMouseEnter.bind(this)), this.video?.addEventListener("mouseleave", this.onMouseLeave.bind(this)), 
    this.hasAttribute("data-disable-controls") && (this.video.addEventListener("play", this.disableControls), 
    this.video.addEventListener("pause", this.disableControls));
  }
});